import { ParamType } from '@forvalter/utils/ParamType';
import {
    clearStorage,
    getFromStorage,
    saveToStorage,
} from '@forvalter/utils/storage';

export enum ExpiryTypeList {
    expired = 'expired',
    expires_within_6m = 'expires_within_6m',
    expires_within_1y = 'expires_within_1y',
    expires_within_2y = 'expires_within_2y',
    expires_within_3y = 'expires_within_3y',
    expires_within_4y = 'expires_within_4y',
    eternal = 'eternal',
}

export class ExpiryType {
    public static get list() {
        return ExpiryTypeList;
    }

    public static get storedSelectedExpiryType() {
        return getFromStorage(ParamType.storedSelectedExpiryType);
    }

    public static set storedSelectedExpiryType(
        value: ExpiryTypeList | string | undefined,
    ) {
        if (value) {
            saveToStorage(ParamType.storedSelectedExpiryType, value);
        } else {
            clearStorage(ParamType.storedSelectedExpiryType);
        }
    }

    public static get default() {
        return ExpiryTypeList.expires_within_4y;
    }
}
